import React from "react";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from "@material-ui/core";
import { Link } from "react-router-dom";
import FormInput from "../components/FormInput";
import Loading from "../components/Loading";
import AjaxError from "../components/AjaxError";
import { gaPageview } from "../utils/dev";
import { isValidPassword } from "../utils/auth";
/**
 * Get URL Paramater
 * @param {string} sParam
 */
// function getURLParameter(sParam) {
//   var sPageURL = window.location.search.substring(1);
//   var sURLVariables = sPageURL.split("&");

//   for (var i = 0; i < sURLVariables.length; i++) {
//     var sParameterName = sURLVariables[i].split("=");
//     if (sParameterName[0] === sParam) {
//       return sParameterName[1];
//     }
//   }
// }

const styles = {
  dialog: {
    heading: {
      fontFamily: "Fresh Sans",
      marginLeft: 25,
      marginTop: 20,
      fontWeight: "bold"
    },
    text: {
      fontSize: 15,
      fontFamily: "Fresh Sans"
    },
    button: {
      fontSize: 15
    }
  }
};

export default class Signup extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    // Bindings
    this.submitNewUser = this.submitNewUser.bind(this);

    // Setup the state
    // let policy = getURLParameter("policy");
    this.state = {
      policyerror: false, //used to display password policy dialog
      error: false,
      errors: [],
      isLoading: false,
      // policy: policy !== undefined ? policy : false,
      fname: "",
      sname: "",
      email: "",
      mobile: "",
      password: "",
      password2: "",
      successDialog: false,
      pet_name: "",
      pet_breed: ""
    };
  }

  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    document.getElementById("main-content").style.margin = "0 0 0";
    gaPageview(this.props.location);
  }
  componentWillUnmount() {
    document.getElementById("main-content").style.margin = "0 0 20px";
  }

  /**
   * Create New User
   * @param {event} e
   */
  submitNewUser(e) {
    e.preventDefault();

    if (this.state.password !== this.state.password2) {
      alert("Passwords do not match");
      return;
    }

    if (this.state.password === this.state.email) {
      alert("Password can not be same as email");
      return;
    }

    if (!isValidPassword(this.state.password)) {
      alert(
        `Passowrd must contain:\n>at least 8 characters\n>at least one lowercase letter (a-z)\n>at least one uppercase letter (A-Z)\n>at least one number (0-9)`
      );
      return;
    }

    this.setState({ isLoading: true });

    axios
      .post(axios.defaults.baseURL + "/user", this.state)
      .then(() => {
        this.setState({
          successDialog: true,
          isLoading: false
        });
      })
      .catch(e => {
        this.setState({
          isLoading: false,
          error: true,
          errors: e.response.data.errors
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <Loading />;
    }

    if (this.state.error) {
      return (
        <AjaxError
          open={this.state.error}
          errors={this.state.errors}
          action={() => {
            this.setState({ error: false });
          }}
        />
      );
    }

    return (
      <div className="container-fluid container-login">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 signup-content">
            {/* Error Dialog */}
            <Dialog open={this.state.policyerror}>
              <p style={styles.dialog.heading}>Password Policy</p>
              <DialogContent>
                <DialogContentText style={styles.dialog.text}>
                  Password must contain
                  <ul>
                    <li>at least 8 characters</li>
                    <li>at least one lowercase letter (a-z)</li>
                    <li>at least one uppercase letter (A-Z)</li>
                    <li>at least one number (0-9)</li>
                  </ul>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    this.setState({ policyerror: false });
                  }}
                >
                  Close
                </button>
              </DialogActions>
            </Dialog>

            {/* Success Dialog */}
            <Dialog open={this.state.successDialog}>
              <p style={styles.dialog.heading}>Successfully Signed Up</p>
              <DialogContent>
                <DialogContentText style={styles.dialog.text}>
                  Congratulations, you've successfully registered for Vetchat.
                  Please login to use Vetchat with your selected email and
                  password.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Link to="/login" className="btn btn-success">
                  Login
                </Link>
              </DialogActions>
            </Dialog>

            {/* Sign Up Form */}
            <form className="login form-signup">
              <div className="image">
                <img
                  src="/images/vetchat-logo-vertical.png"
                  alt="vetchat logo"
                  style={{ maxWidth: "100%" }}
                />
                <p className="space-top">Sign up to Vetchat!</p>
              </div>
              <div className="signup-input">
                {FormInput(this, "First name", "fname", "text")}
                <span className="form-control-feedback glyphicon glyphicon-user" />
              </div>
              <div className="signup-input">
                {FormInput(this, "Surname", "sname", "text")}
                <span className="form-control-feedback glyphicon glyphicon-user" />
              </div>
              <div className="signup-input">
                {FormInput(this, "Email", "email", "email")}
                <span className="form-control-feedback glyphicon glyphicon-envelope" />
              </div>
              <div className="signup-input">
                {FormInput(this, "Password", "password", "password")}
                <span className="form-control-feedback glyphicon glyphicon-lock" />
              </div>
              <div className="signup-input">
                {FormInput(this, "Re-enter password", "password2", "password")}
                <span className="form-control-feedback glyphicon glyphicon-lock" />
              </div>
              <div className="password-policy">
                <span
                  className="pp-action"
                  onClick={() => {
                    this.setState({ policyerror: true });
                  }}
                >
                  Password Policy
                </span>
              </div>

              {/* Submit Button */}
              <div className="extra-actions">
                <div className="submit-login">
                  <button
                    className="btn btn-full btn-login"
                    onClick={this.submitNewUser}
                  >
                    Sign up
                  </button>
                </div>
                <a href="/login">Back</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
